
export const authbasic = {

  // branchtype: {
  //   service: {
  //     name: 'branchtype',
  //     title: 'Branch Type',
  //   }
  // },

  gender: {
    service: {
      name: 'gender',
      title: 'Gender',
    }
  },

  version: {
    service: {
      name: 'version',
      title: 'App Version',
    }
  },

};
